// Stock counts (migration 070), spread into `mutations` (shared/mutations.ts): the day's list and each count. Rules
// and implementations: server/src/mutations/counts.ts; the picking: shared/counts.ts. Anyone who works the warehouse
// counts, receivers too; only admins see counts against the books (Mitch: "I do not want to incentivize fudging count
// numbers … the reporting dashboard should only be available to admins").
import { z } from "zod";
import { ADMIN, custom } from "./mutation-kit.ts";

const COUNTERS = ["admin", "inventory", "receiving"] as const;

export const countMutations = {
  /** Makes today's list (HHL's day) if nobody has yet: the same list for everyone, all day. Returns { day, made }. */
  "count.make_day": custom(z.object({}), COUNTERS),
  /** Admins: every SKU on today's list not counted yet is replaced by the next best (they're left out today). */
  "count.pick_again": custom(z.object({}), ADMIN),
  /** Admins: takes a SKU not counted yet off today's list (left out today); the next best takes its place. */
  "count.drop": custom(z.object({ task_id: z.uuid() }), ADMIN),
  /** Admins: puts a SKU on today's list to count (on top of the day's limits), at the HHL location holding the most of it. */
  "count.add": custom(z.object({ item_id: z.uuid() }), ADMIN),
  /**
   * One count of an item at an HHL location, as counted (the browser makes the id; the same id twice is a no-op): the
   * number and an optional note. It's accepted as it is and changes no stock; what the books said then is kept for
   * admins' report, never shown to whoever counts. A recount on the list replaces the task's count. Returns { id }.
   */
  "stock_count.record": custom(
    z.object({
      id: z.uuid(),
      item_id: z.uuid(),
      location_id: z.uuid(),
      counted: z.number().int("Count whole units").min(0, "A count is 0 or more").max(10_000_000),
      note: z.string().trim().max(1000).default(""),
      task_id: z.uuid().optional(),
    }),
    COUNTERS,
  ),
};
